import Decimal from "decimal.js";
import { AssertionError } from "../assertionError";

export function assertIsDecimalFinite(value: Decimal, contextName: string) {
  if (!value.isFinite()) {
    throw new AssertionError(
      `Assertion error: ${contextName} is not Finite number`
    );
  }
}
